import request from './request';

/**
 * 执行批次 API
 * 用于两阶段评分的批次管理
 */

// ==================== 批次管理 ====================

/**
 * 获取批次列表
 * @param {Object} params - 查询参数
 * @param {number} [params.test_plan_id] - 评估计划ID
 * @param {string} [params.status] - 状态筛选
 * @param {string} [params.phase2_status] - 阶段2状态筛选
 * @param {string} [params.start_date] - 开始日期
 * @param {string} [params.end_date] - 结束日期
 * @param {number} [params.page=1] - 页码
 * @param {number} [params.pageSize=20] - 每页数量
 */
export function getPlanExecutions(params) {
  return request({
    url: '/eval/plan-executions',
    method: 'get',
    params
  });
}

/**
 * 获取批次详情
 * @param {number} id - 批次ID
 */
export function getPlanExecutionDetail(id) {
  return request({
    url: `/eval/plan-executions/${id}`,
    method: 'get'
  });
}

/**
 * 获取批次的执行记录列表
 * @param {number} id - 批次ID
 * @param {Object} [params] - 分页参数
 */
export function getPlanExecutionRecords(id, params = {}) {
  return request({
    url: `/eval/plan-executions/${id}/records`,
    method: 'get',
    params
  });
}

// ==================== 批次对比 ====================

/**
 * 批次数据对比
 * @param {number} batchId1 - 批次1 ID
 * @param {number} batchId2 - 批次2 ID
 */
export function comparePlanExecutions(batchId1, batchId2) {
  return request({
    url: '/eval/plan-executions/compare',
    method: 'post',
    data: {
      batch_id_1: batchId1,
      batch_id_2: batchId2
    }
  });
}

/**
 * 批次改进分析（LLM）
 * @param {number} batchId1 - 批次1 ID
 * @param {number} batchId2 - 批次2 ID
 */
export function generateComparisonAnalysis(batchId1, batchId2) {
  return request({
    url: '/eval/plan-executions/compare/analyze',
    method: 'post',
    data: {
      batch_id_1: batchId1,
      batch_id_2: batchId2
    }
  });
}

// ==================== 执行记录对比 ====================

/**
 * 执行记录数据对比
 * @param {number} executionId1 - 执行记录1 ID
 * @param {number} executionId2 - 执行记录2 ID
 */
export function compareExecutions(executionId1, executionId2) {
  return request({
    url: '/eval/plan-executions/executions/compare',
    method: 'post',
    data: {
      execution_id_1: executionId1,
      execution_id_2: executionId2
    }
  });
}

